var React = require('react');

function AngleTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.8158 12.8449C16.5924 13.0329 16.243 13.05 15.9967 12.8962L15.9262 12.8449L10.5 8.27835L5.07382 12.8449C4.8505 13.0329 4.50105 13.05 4.25479 12.8962L4.18424 12.8449C3.96092 12.657 3.94062 12.3629 4.12333 12.1556L4.18424 12.0962L10.0552 7.15506C10.2785 6.96711 10.628 6.95002 10.8742 7.1038L10.9448 7.15506L16.8158 12.0962C17.0614 12.303 17.0614 12.6382 16.8158 12.8449Z","fill":"white"}));
}

AngleTop.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = AngleTop;

AngleTop.default = AngleTop;
